// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qz-9";
export var arrowButtonContainer = "_qz-5";
export var arrowButtonIcon = "_qz-6";
export var carouselArrowButton = "_qz-2";
export var carouselElementContainer = "_qz-1";
export var currentSlide = "_qz-8";
export var left = "_qz-3";
export var otherSlide = "_qz-a";
export var productCarouselContainer = "_qz-0";
export var right = "_qz-4";
export var sliderOverflow = "_qz-7";